import { useContext } from 'react'
import { CollectionContext } from '../../state/CollectionContext'
import globalStyle from '../../styles/common.module.css'
import style from './article.module.css'


export function EditArticle() {
  const context = useContext(CollectionContext)
  const story = context.state.find((story) => story.isActive)
  if (!story) return null

  return (
    <div className={[globalStyle.grid6].join(' ')}>
      {
        story.content.map((section, i) => {
          return (
            <p key={`edit-p${i}`} className={[globalStyle.bodyLG, style.chunks].join(' ')}>
              {
                section.map((item, j) => {
                  return (
                    <span key={`edit-${j}${i}`}>
                      <span
                        className={[
                          style.selectable, 
                          item.userComment || item.isSelected ? style.selected : '', 
                          item.isSelected ? style.active : ''
                        ].join(' ')}
                        tabIndex={0}
                        onClick={() => context.dispatch({ type: 'select_chunk', chunkId: item.id })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            context.dispatch({ type: 'select_chunk', chunkId: item.id })
                          }
                        }}
                      >
                        {item.italic ? <i>{item.text}</i> : item.text} 
                      </span>
                      <span>{item.trailing}</span>
                    </span>
                  )
                })
              }
            </p>
          )
        })
      }
    </div>
  )
}

